import { render } from "./PaymentPartialAgree.html?vue&type=template&id=60e70bac"
import script from "./PaymentPartialAgree.js?vue&type=script&lang=js"
export * from "./PaymentPartialAgree.js?vue&type=script&lang=js"

import "./PaymentPartialAgree.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__